<template>
  <div class="register">
    <v-layout row justify-center>
      <v-flex xs12 sm6 md6 lg4>
        <p class="display-1 text-no-wrap text-md-center font-weight-thin font-italic"></p>
        <v-card class="card-main">
          <v-img
            src="https://storage.googleapis.com/spitzer-risc-logos/new-clinic-little.png"
            lazy-src="https://picsum.photos/id/11/10/6"
            class="grey lighten-2"
          ></v-img>
          <v-card-title primary-title>
            <v-card-text>
              <v-container grid-list-md text-xs-center>
                <v-layout row wrap>
                    <v-progress-linear :indeterminate="true" v-show="loadingOk === true"></v-progress-linear>
                  <v-flex xs12>
                    <v-form v-model="valid" ref="form" lazy-validation>
                      <v-flex xs12 sm12>
                        <v-text-field
                          class="username"
                          label="E-Mail/Usuário"
                          v-model="auth.username"
                          :counter="40"
                          :rules="[v => !!v || 'E-mail obrigatório!!']" required
                          prepend-icon="email"
                        ></v-text-field>
                      </v-flex>
                    <div class="buttons">
                      <router-link to="/patient/login">
                        <v-btn @click="clear">Voltar</v-btn>
                      </router-link>
                      <v-btn
                        color = 'primary'
                        @click="searchEmail"
                        :disabled="!buttonEnabled"
                      >
                        Avançar
                      </v-btn>
                      <!-- <v-btn
                        :loading="loadingButton"
                        :disabled="loadingButton"
                        color="primary"
                        @click="searchEmail"
                      >
                        Avançar
                        <template v-slot:loader>
                          <span class="custom-loader">
                            <v-icon light>cached</v-icon>
                          </span>
                        </template>
                      </v-btn>                       -->
                    </div>
                  </v-form>
                </v-flex>
              </v-layout>

              <v-snackbar
                :timeout="snackbarConfig.timeout"
                :color="snackbarConfig.color"
                :multi-line="snackbarConfig.mode === 'multi-line'"
                :vertical="snackbarConfig.mode === 'vertical'"
                v-model="snackbarConfig.snackbar"
              >
                {{ snackbarConfig.text }}
                <v-btn dark flat @click.native="snackbarConfig.snackbar = false">Fechar</v-btn>
              </v-snackbar>

              </v-container>
            </v-card-text>
          </v-card-title>
          <v-card-actions>
            <div>© <router-link to="/auth/sing-up">2017</router-link> - {{ new Date().getFullYear() }} <a href="http://www.spitzer.io">Spitzer.io</a> - Todos os direitos reservados</div>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'Register',
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]
      }
    },
    computed: {
      ...mapGetters({
        customer: 'customer'
      }),
      ...mapGetters('app', ['getTheme']),
      ...mapGetters('auth', ['getSearchUser'])
    },
    data: () => ({
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      buttonEnabled: true,
      selected: [],
      sectors: [],
      items: [],
      valid: false,
      loadingOk: false,
      loadingButton: false,
      loader: null,
      e1: true,
      p1: true,
      custom: true,
      auth: {
        username: null
      },
      checkbox: false
    }),
    mounted () {
      if (process.env.NODE_ENV !== 'production') {
        this.auth.username = 'andreza_82@hotmail.com'
      }
    },
    methods: {
      ...mapActions('auth', ['setSearchEmail', 'setRegister', 'setSearchEmailNew']),
      register (items) {
        this.loadingOk = true
        this.setRegister(items).then(() => {
          this.$router.push('/auth/register')
          this.loadingOk = false
        })
      },
      searchEmail () {
        this.$validator.validateAll()
        if (this.$refs.form.validate()) {
          this.loader = true
          this.loadingOk = true
          this.buttonEnabled = false
          // this.setSearchEmail(this.auth.username).then((item) => {
          this.setSearchEmailNew(this.auth.username).then((item) => {
            if (item) {
              this.$router.push('/auth/register')
            } else {
              this.loadingOk = false
              this.buttonEnabled = true
              this.snackbarConfig.snackbar = true
              this.snackbarConfig.text = 'Nenhum registro foi encontrado, deseja fazer manualamente?'
            }
          }).catch((err) => {
            console.error(err)
            this.buttonEnabled = true
            this.loadingOk = false
            this.snackbarConfig.snackbar = true
            this.snackbarConfig.text = err.response.data.result.error
          })
        }
      },
      clear () {
        this.$refs.form.reset()
      }
    }
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/auth/SearchUser.vue